// @flow

import React, { Component } from "react";
import { Link } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import PermIdentity from "@material-ui/icons/PermIdentity";
import Dashboard from "@material-ui/icons/Dashboard";
import AccountCircle from "@material-ui/icons/AccountCircle";
import ExitToApp from "@material-ui/icons/ExitToApp";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import type { CurrentUser } from "containers/Security/types";

type Props = {
  classes: Object,
  logout: Function,
} & CurrentUser;

type State = {
  anchorEl: ?React$Element<*>,
  open: boolean,
};

const styles = (theme) => ({
  div: {
    marginLeft: "auto",
  },
  button: {
    textTransform: "none",
    color: "rgba(0,0,0,.54)",
  },
  userIcon: {
    color: theme.palette.primary.main,
    marginRight: 6,
  },
  menu: {
    "& a": {
      textDecoration: "none",
    },
  },
});

class UserMenu extends Component<Props, State> {
  state: State = {
    anchorEl: undefined,
    open: false,
  };

  handleClick = (event) => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  render() {
    return (
      <div className={this.props.classes.div}>
        <Button
          aria-owns={this.state.open ? "user-menu" : null}
          aria-haspopup="true"
          onClick={this.handleClick}
          className={this.props.classes.button}
        >
          <PermIdentity className={this.props.classes.userIcon} />
          {this.props.currentUser.get("email")}
          <ArrowDropDown />
        </Button>
        <Menu
          className={this.props.classes.menu}
          id="user-menu"
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={this.handleRequestClose}
        >
          <ListItem button>
            <ListItemText
              primary={`Welcome, ${this.props.currentUser.get("email")}!`}
            />
          </ListItem>
          <Divider light />
          <Link to="/private/dashboard">
            <MenuItem onClick={this.handleRequestClose}>
              <Dashboard className={this.props.classes.userIcon} />
              Dashboard
            </MenuItem>
          </Link>
          <Link to={`/private/profile/${this.props.currentUser.get("uid")}`}>
            <MenuItem onClick={this.handleRequestClose}>
              <AccountCircle className={this.props.classes.userIcon} />
              Profile
            </MenuItem>
          </Link>
          <Divider light />
          <MenuItem
            onClick={() => {
              this.handleRequestClose();
              this.props.logout();
            }}
          >
            <ExitToApp className={this.props.classes.userIcon} />
            Logout
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

export default withStyles(styles)(UserMenu);
